import { render } from "./PdfPreview.vue?vue&type=template&id=ba5e26c2&scoped=true"
import script from "./PdfPreview.vue?vue&type=script&lang=js"
export * from "./PdfPreview.vue?vue&type=script&lang=js"

import "./PdfPreview.vue?vue&type=style&index=0&id=ba5e26c2&scoped=true&lang=css"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5e26c2"]])

export default __exports__